import * as React from 'react';
import { mainLogo } from 'images';
import { useStyles } from './MainLogo.styles';
import { Image } from 'components';
import { Grid } from '@material-ui/core';
import { useBreakpoints } from "utils";

type MainLogoProps = {};

const MainLogo: React.FC<MainLogoProps> = () => {
  const styles = useStyles();
  const { isMd } = useBreakpoints()

  if (!isMd) return null;

  return (
    <Grid container alignItems="flex-start" className={styles.container}>
      <Image {...mainLogo} width={142} height="auto"/>
    </Grid>
  );
};

export default MainLogo;